import React from "react";
import { ModalBuilder, Modal } from "@redriver/cinnamon";
import { updateDocumentType } from "./actions";
import DocumentTypeForm from "./DocumentTypeForm";

const EditDocumentType = ({ onUpdated, onCancel, documentType }) => (
  <ModalBuilder
    withForm
    initialData={documentType}
    submitAction={updateDocumentType}
    submitParams={documentType.id}
    onSubmitted={onUpdated}
    onCancel={onCancel}
    renderModal={(modalProps, formProps) => (
      <Modal.Edit {...modalProps} header="Edit Document Type">
        <DocumentTypeForm {...formProps} isEdit />
      </Modal.Edit>
    )}
  />
);

export default EditDocumentType;
